import type { StreamSubscriptionActions } from 'tricklejs/dist/stream_subscription'
import type { FirebaseRepository } from '../models/FirebaseRepository'
import { type StaticModelCollection } from '../types'
import { Cubit } from './core'
import { PromptRubricType } from '../models/PromptRubricType'
import { getRoomPromptTypes, RubricType } from '../firestore/PromptRubricType'
import { computed, observable } from 'mobx'

export class RubricTypeCubit extends Cubit {
  repository: FirebaseRepository
  empty: PromptRubricType
  _promptTypes: StaticModelCollection<PromptRubricType>
  _promptTypesStream: StreamSubscriptionActions | undefined = undefined
  _typesById = observable.map<string, PromptRubricType>()

  constructor(repository: FirebaseRepository) {
    super()
    this.repository = repository
    this._promptTypes = PromptRubricType.emptyCollection(this.repository)
    this.empty = PromptRubricType.empty(this.repository)
  }

  @computed
  get promptTypes() {
    this.startPromptTypesStreamIfNotRunning()
    return this._promptTypes
  }

  startPromptTypesStreamIfNotRunning() {
    if (this._promptTypesStream) return

    const stream = getRoomPromptTypes(this.repository)
    this._promptTypesStream = stream.listen((models) => {
      this._promptTypes.replaceModels(models)

      for (const model of models) {
        this._typesById.set(model.id, model)
      }
    })
  }

  @computed
  get blooms() {
    return this.getRubricTypeByTypeId(RubricType.blooms)
  }

  @computed
  get passFail() {
    return this.getRubricTypeByTypeId(RubricType.passFail)
  }

  @computed
  get decisionMaking() {
    return this.getRubricTypeByTypeId(RubricType.decisionMaking)
  }

  @computed
  get evidence() {
    return this.getRubricTypeByTypeId(RubricType.evidence)
  }

  @computed
  get peerEngagement() {
    return this.getRubricTypeByTypeId(RubricType.peerEngagement)
  }

  @computed
  get criticalThinking() {
    return this.getRubricTypeByTypeId(RubricType.criticalThinking)
  }

  getRubricTypeByTypeId(type: RubricType) {
    return (
      this.promptTypes.models.find((model) => model.id === type.toString()) ||
      this.empty
    )
  }
}
